/* Balance promotional cards while guidance cards keep one product slot.
 * Product order, page boundaries and the number of products remain unchanged. */
(function () {
  function spansFor(items, columns) {
    if (items.includes('full')) {
      const result = [];
      let start = 0;
      items.forEach((item, index) => {
        if (item !== 'full') return;
        result.push(...spansFor(items.slice(start, index), columns), columns);
        start = index + 1;
      });
      return result.concat(spansFor(items.slice(start), columns));
    }
    const spans = items.map(() => 1);
    let remaining = (columns - items.length % columns) % columns;
    let position = 0;
    items.forEach((isCard, index) => {
      const extra = isCard ? Math.min(remaining, columns - position % columns - 1) : 0;
      spans[index] += extra;
      remaining -= extra;
      position += spans[index];
    });
    return spans;
  }
  function positionPromo(grid, mobile = false) {
    const children = [...grid.children];
    const promo = children.find(child => child.matches('.swap-promo-card--lifestyle'));
    if (!promo) return;
    const products = children.filter(child => child.classList.contains('group/product') && getComputedStyle(child).display !== 'none');
    if (!products.length) return;
    const fullMobilePromo = mobile && !promo.matches('.swap-promo-card--photo-only');
    const anchor = fullMobilePromo ? products[Math.min(2, products.length) - 1].nextSibling : products[0];
    if (anchor === promo || promo.nextSibling === anchor) return;
    const move = () => grid.insertBefore(promo, anchor);
    if (typeof window !== 'undefined' && window.Alpine?.mutateDom) window.Alpine.mutateDom(move);
    else move();
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { spansFor, positionPromo };
  if (typeof document === 'undefined') return;

  const grids = new Map();
  const selector = '.swap-collection-grid';
  const cardSelector = '.build-grid-feature-card, .swap-promo-card, .acquisition-card-container';
  const stretchSelector = '.swap-promo-card:not([data-grid-slot="single"]), .acquisition-card-container';
  function connect(grid) {
    let frame;
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(balance);
    };
    const mutations = new MutationObserver(schedule);
    const resize = new ResizeObserver(schedule);
    function balance() {
      frame = null;
      mutations.disconnect();
      positionPromo(grid, typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches);
      const children = [...grid.children];
      // Clear desktop spans before measuring: stale spans create implicit columns
      // after a breakpoint change and would otherwise perpetuate the wrong count.
      children.filter(child => child.matches(cardSelector)).forEach(child => child.style.removeProperty('grid-column'));
      const visible = children.filter(child => getComputedStyle(child).display !== 'none');
      const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
      const mobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 1023px)').matches;
      const fullRow = child => child.matches('.swap-promo-card--set') || (mobile && child.matches('.swap-promo-card--lifestyle:not(.swap-promo-card--photo-only)'));
      const spans = spansFor(visible.map(child => fullRow(child) ? 'full' : child.matches(stretchSelector) && !child.matches('.swap-promo-card--photo-only')), columns || 1);
      visible.forEach((child, index) => {
        if (fullRow(child)) child.style.gridColumn = '1 / -1';
        else if (child.matches(stretchSelector) && spans[index] > 1) child.style.gridColumn = `span ${spans[index]}`;
      });
      mutations.observe(grid, { childList: true });
      children.forEach(child => mutations.observe(child, { attributes: true, attributeFilter: ['style', 'class'] }));
    }
    resize.observe(grid);
    schedule();
    grids.set(grid, () => { mutations.disconnect(); resize.disconnect(); cancelAnimationFrame(frame); });
  }
  function discover() {
    for (const [grid, disconnect] of grids) {
      if (!grid.isConnected) { disconnect(); grids.delete(grid); }
    }
    document.querySelectorAll(selector).forEach(grid => { if (!grids.has(grid)) connect(grid); });
  }
  let discoveryFrame;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) return;
    if (!discoveryFrame) discoveryFrame = requestAnimationFrame(() => { discoveryFrame = null; discover(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  discover();
})();
